import { API_URL } from "env";

interface LocationItem {
    id: number;
    position: number;
    name: string;
    prefix?: string;
    status: number;
    district_id?: number;
    province_id?: number;
    created_at: string | null;
}

async function getProvinces(): Promise<LocationItem[]> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/provinces`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data.status) {
            throw new Error('Failed to fetch provinces');
        }
        return data.data.items || [];
    } catch (error) {
        console.error("Error fetching provinces:", error);
        throw error;
    }
}

async function getDistricts(provinceID: string): Promise<LocationItem[]> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/districts?province_id=${provinceID}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data.status) {
            throw new Error('Failed to fetch districts');
        }
        return data.data.items || [];   
    } catch (error) {
        console.error("Error fetching districts:", error);
        throw error;
    }
}

async function getWards(districtID: string): Promise<LocationItem[]> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/wards?district_id=${districtID}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data.status) {
            throw new Error('Failed to fetch wards');
        }
        return data.data.items || [];
    } catch (error) {
        console.error("Error fetching wards:", error);
        throw error;
    }
}

export { getProvinces, getDistricts, getWards };